var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmailSent(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "245px",
    height: "173px",
    viewBox: "0 0 245 173",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "41") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9684134%",
    y1: "-2.3164557%",
    x2: "49.9684134%",
    y2: "101.075949%",
    id: "linearGradient-1"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF0F5",
    offset: "99.64%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M115,51.7096764 C115,61.8104906 106.721138,69.9944611 96.3945783,69.9944611 C96.21568,69.9944611 94.7019253,69.9944611 83.5744519,69.9944611 C75.8295322,69.9944611 63.4552754,69.9944611 43.6925194,69.9944611 L34.2563229,69.9944611 C21.8820661,70.2663538 12,60.4918109 12,48.7188566 C12,36.8371453 21.9715152,26.9946292 34.5232942,27.6063878 C45.2957233,-5.6324958 94.6138523,-0.969535848 98.7973199,33.4112972 C108.055994,34.5532465 115,42.2885941 115,51.7096764 Z",
    id: "path-2"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-37.4%",
    y: "-42.3%",
    width: "174.8%",
    height: "218.5%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 11,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.396078431   0 0 0 0 0.478431373   0 0 0 0 0.576470588  0 0 0 0.27 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-5.31785067%",
    y1: "-10.776663%",
    x2: "39.0037351%",
    y2: "37.9412858%",
    id: "linearGradient-4"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCCBE1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "99.42%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-4.68324711%",
    y1: "27.0625%",
    x2: "34.3377963%",
    y2: "42.3690375%",
    id: "linearGradient-5"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCE1D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9684134%",
    y1: "-2.3164557%",
    x2: "49.9684134%",
    y2: "101.075949%",
    id: "linearGradient-6"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF0F5",
    offset: "99.64%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M213,99.7314183 C213,110.932255 203.917605,119.994375 192.587638,119.994375 C192.392436,119.994375 190.731844,119.994375 178.523467,119.994375 C170.026678,119.994375 156.451887,119.994375 134.769337,119.994375 L124.416754,119.994375 C110.840588,120.282279 100,109.479025 100,96.4273773 C100,83.2660519 110.938189,72.3668294 124.709557,73.0386053 C136.52753,36.2280235 190.634242,41.3828759 195.22424,79.4684612 C205.381621,80.7434646 213,89.3120357 213,99.7314183 Z",
    id: "path-7"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-34.1%",
    y: "-38.2%",
    width: "168.1%",
    height: "206.9%",
    filterUnits: "objectBoundingBox",
    id: "filter-8"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 11,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.396078431   0 0 0 0 0.478431373   0 0 0 0 0.576470588  0 0 0 0.27 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-5.32022358%",
    y1: "-7.83013043%",
    x2: "38.7489016%",
    y2: "38.2680826%",
    id: "linearGradient-9"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCE1D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-4.68217934%",
    y1: "27.6915102%",
    x2: "34.3391362%",
    y2: "42.5876472%",
    id: "linearGradient-10"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCE1D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "49.9684134%",
    y1: "-2.3164557%",
    x2: "49.9684134%",
    y2: "101.075949%",
    id: "linearGradient-11"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#ECF0F5",
    offset: "99.64%"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M99,122.456422 C99,128.836929 93.8558114,133.996221 87.4392569,133.996221 C87.328438,133.996221 86.388529,133.996221 79.4739734,133.996221 C74.6608735,133.996221 66.9719532,133.996221 54.691571,133.996221 L48.8291114,133.996221 C41.1401911,134.174601 35,128.013638 35,120.576573 C35,113.084623 41.1949165,106.868774 48.9946557,107.266698 C55.6875735,86.2864919 86.3324355,89.236619 88.9318925,110.930344 C94.6849013,111.643863 99,116.528725 99,122.456422 Z",
    id: "path-12"
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-60.2%",
    y: "-67.1%",
    width: "220.3%",
    height: "287.8%",
    filterUnits: "objectBoundingBox",
    id: "filter-13"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 11,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 11,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0.396078431   0 0 0 0 0.478431373   0 0 0 0 0.576470588  0 0 0 0.27 0",
    type: "matrix",
    in: "shadowBlurOuter1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-5.32544379%",
    y1: "-10.8268888%",
    x2: "39%",
    y2: "37.953599%",
    id: "linearGradient-14"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCCBE1",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "99.42%"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "-4.68069546%",
    y1: "27.0333333%",
    x2: "34.3390353%",
    y2: "42.3440133%",
    id: "linearGradient-15"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BCE1D6",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFFFFF",
    stopOpacity: 0,
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.3---L---Resend-Email-(Sent)",
    transform: "translate(-204.000000, -400.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: 41,
    transform: "translate(214.000000, 406.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.5,148 C138.882643,148 170,116.943898 170,78.5 C170,40.0561024 138.882643,9 100.5,9 C62.117357,9 31,40.0561024 31,78.5 C31,116.943898 62.117357,148 100.5,148 Z",
    id: "Path",
    fill: "#D2E4E6"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-3)",
    xlinkHref: "#path-2"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-1)",
    xlinkHref: "#path-2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M95.5006841,70 C105.679413,70 114,61.7227796 114,51.5068748 C114,41.2772204 105.679413,33 95.5006841,33 C85.3205873,33 77,41.2772204 77,51.5068748 C77,61.7227796 85.3205873,70 95.5006841,70 Z",
    id: "Path",
    fill: "url(#linearGradient-4)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M65.9993143,71 C84.1856885,71 99,56.2325 99,38 C99,19.7675 84.1856885,5 65.9993143,5 C47.8143115,5 33,19.7675 33,38 C33,56.2325 47.7251761,71 65.9993143,71 Z",
    id: "Path",
    fill: "url(#linearGradient-5)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-8)",
    xlinkHref: "#path-7"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-6)",
    xlinkHref: "#path-7"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M192.5,120 C203.780591,120 213,111.05548 213,100 C213,88.9445196 203.780591,80 192.5,80 C181.220789,80 172,88.9445196 172,100 C172,111.05548 181.220789,120 192.5,120 Z",
    id: "Path",
    fill: "url(#linearGradient-9)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.5,120 C179.614359,120 196,103.898331 196,84 C196,64.1153263 179.614359,48 159.5,48 C139.385641,48 123,64.1153263 123,84 C123,103.898331 139.28759,120 159.5,120 Z",
    id: "Path",
    fill: "url(#linearGradient-10)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Path",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-13)",
    xlinkHref: "#path-12"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "url(#linearGradient-11)",
    xlinkHref: "#path-12"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M87.5,134 C93.8270414,134 99,128.855443 99,122.493159 C99,116.144557 93.8270414,111 87.5,111 C81.1715976,111 76,116.144557 76,122.493159 C76,128.855443 81.1715976,134 87.5,134 Z",
    id: "Path",
    fill: "url(#linearGradient-14)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M68.5006815,134 C79.7971145,134 89,124.816 89,113.5 C89,102.170333 79.7971145,93 68.5006815,93 C57.2028855,93 48,102.170333 48,113.5 C48,124.816 57.1483661,134 68.5006815,134 Z",
    id: "Path",
    fill: "url(#linearGradient-15)",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95,52.2366574 L86.212525,59.4283597 C84.5736176,60.6743796 82.4350433,59.7940394 81.9327115,57.6541356 L79,37",
    id: "Path",
    fill: "#195C62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M182,0 L176.200834,5.37288152 L115.517588,62.0348514 C112.752106,64.6938795 108.47594,64.5842289 105.625618,62.1307957 L83.8246967,42.0373154 L79.4513759,37.9665352 L67.3932713,26.6176937 C64.8097827,24.1094352 65.9879521,19.5589335 69.5361438,18.9969739 L169.276866,2.4808458 L182,0 Z",
    id: "Path",
    fill: "#599CA2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#195C62",
    points: "182 0 176.180333 5.4122288 83.65903 42 79 37.9684418 169.43353 2.16765286"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13,113.476553 L9.33110616,116.728378 C8.64643653,117.297448 7.72271715,116.931617 7.48496659,116.010267 L6,107",
    id: "Path",
    fill: "#195C62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M51,90 L48.5015316,92.4250549 L22.3477633,118.081033 C21.1565687,119.279782 19.2661347,119.279782 17.9768255,118.232599 L8.10041305,109.648456 L6.12015573,107.912337 L0.654756092,103.062227 C-0.515710025,101.987487 -0.0486290955,99.9757939 1.51291366,99.6864408 L45.406084,91.2400849 L51,90 Z",
    id: "Path",
    fill: "#599CA2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#195C62",
    points: "51 90 48.4966154 92.3615819 8.10323077 109 6 107.336158 45.4809231 91.0600282"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M89,127.650562 L81.6608555,133.50913 C80.2915062,134.534379 78.4453679,133.881948 77.968579,132.217582 L75,116",
    id: "Path",
    fill: "#195C62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157,84 L152.443267,88.4545875 L104.752392,135.310248 C102.580684,137.510045 99.1318242,137.510045 96.7798285,135.61272 L78.7730931,119.925423 L75.1590846,116.735719 L65.1951007,107.881538 C63.0591749,105.929219 63.911068,102.24456 66.7585103,101.70836 L146.799303,86.2685399 L157,84 Z",
    id: "Path",
    fill: "#599CA2"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#195C62",
    points: "157 84 152.436253 88.3733128 78.832059 119 75 115.935981 146.942395 85.9706903"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmailSent);
export default __webpack_public_path__ + "static/media/email_sent.40429802e7159c05aa3129b4f0ada011.svg";
export { ForwardRef as ReactComponent };